module.exports = ['$translate', $translate => (bytes, precision) => {
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
    return '-';
  }
  if (typeof (precision) === 'undefined') {
    precision = 1;
  }
  const units = [
    $translate.instant('bytes.bytes'),
    $translate.instant('bytes.kilobytes'),
    $translate.instant('bytes.megabytes'),
    $translate.instant('bytes.gigabytes'),
  ];
  const number = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / (1024 ** Math.floor(number))).toFixed(precision)} ${units[number]}`;
}];



// WEBPACK FOOTER //
// ./main/filters/bytes-size-filter.js